export const ExpandedTranshipmentManagementCardHandler = {
  getExpandedManagementCardObject(context) {
    return context.$store.getters.expandedTranshipmentManagementCardObject;
  },
  getIsCardExpanded(context) {
    return context.$store.getters.isTranshipmentCardExpanded;
  },
  setExpandedManagementCardObject(context, expandedTranshipmentManagementCardObject) {
    context.$store.commit('SET_TRANSHIPMENT_EXPANDED_MANAGEMENT_CARD_OBJECT', expandedTranshipmentManagementCardObject);
  },
  setIsCardExpanded(context, isTranshipmentCardExpanded) {
    context.$store.commit('SET_IS_TRANSHIPMENT_CARD_EXPANDED', isTranshipmentCardExpanded);
  },
  setShouldRefreshWhenTimerEnds(context, shouldTranshipmentRefreshWhenTimerEnds) {
    context.$store.commit('SET_SHOULD_REFRESH_WHEN_TRANSHIPMENT_TIMER_ENDS', shouldTranshipmentRefreshWhenTimerEnds);
  }
};

const state = {
  expandedTranshipmentManagementCardObject: null,
  isTranshipmentCardExpanded: false,
  shouldTranshipmentRefreshWhenTimerEnds: false
};

const getters = {
  expandedTranshipmentManagementCardObject: (state) => {
    return state.expandedTranshipmentManagementCardObject;
  },
  isTranshipmentCardExpanded: (state) => {
    return state.isTranshipmentCardExpanded;
  },
  shouldTranshipmentRefreshWhenTimerEnds: (state) => {
    return state.shouldTranshipmentRefreshWhenTimerEnds;
  }
};

const mutations = {
  SET_TRANSHIPMENT_EXPANDED_MANAGEMENT_CARD_OBJECT: (state, expandedTranshipmentManagementCardObject) => {
    state.expandedTranshipmentManagementCardObject = expandedTranshipmentManagementCardObject;
  },
  SET_IS_TRANSHIPMENT_CARD_EXPANDED: (state, isTranshipmentCardExpanded) => {
    state.isTranshipmentCardExpanded = isTranshipmentCardExpanded;
  },
  SET_SHOULD_REFRESH_WHEN_TRANSHIPMENT_TIMER_ENDS: (state, shouldTranshipmentRefreshWhenTimerEnds) => {
    state.shouldTranshipmentRefreshWhenTimerEnds = shouldTranshipmentRefreshWhenTimerEnds;
  }
};

export default {
  state,
  getters,
  mutations
};
